import { GardenTaskCategory } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/garden-task-category.enum';

/** Pictogramme d'un geste, d'après sa nature ; le titre porte le verbe. */
export const TASK_EMOJIS: Record<GardenTaskCategory, string> = {
  [GardenTaskCategory.SOW_SHELTERED]: '🪴',
  [GardenTaskCategory.SOW]: '🌱',
  [GardenTaskCategory.PLANT]: '🌿',
  [GardenTaskCategory.CARE]: '✂️',
  [GardenTaskCategory.PROTECT]: '🧤',
  [GardenTaskCategory.SOIL]: '🪱',
  [GardenTaskCategory.HARVEST]: '🧺',
};
